import { render } from "./IconTrekAgeRange.vue?vue&type=template&id=89fc5384"
import script from "./IconTrekAgeRange.vue?vue&type=script&lang=js"
export * from "./IconTrekAgeRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__